import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  setRequestBody,
  getPageDescriptionBody,
  setAppliedFilters,
  deleteEntityFilter,
  deleteAppliedFilters,
  setRequestBodyDataAutomation,
  validateAutomationData,
  getCounterpartyIdWithCorporateIdList,
  updateCrawlerStatusinCaseData,
  getStatusData,
  updateCaseDataWithCrawlerFlag,
  getUrlFilter,
  createFilterUrl
} from './Helper';
import { Col, Label, Card, CardBody, Button, TabContent, TabPane, Nav, NavItem, NavLink, Row, FormGroup, Form, Input } from 'reactstrap';
import classnames from 'classnames';
import TableView from './Table/index';
import './Cases.css';
import withAuth from '../../../components/Services/WithAuth';
import { viewAllCases, viewPaginatedCases, getCorporateName, getCaseEPFDetails, downloadPendingCases, downloadPendingCasesSuccess, fetchProductsByCorporates } from "./Actions";
import { dataAtuomationInitiate } from '../CommonComponent/action';
import * as constant from './constants';
import FilterFormTypeOne from '../../../components/ReusableComponents/FilterFormTypeOne/index'
import { toast } from 'react-toastify';
import { setPageView, goolgeAnalyticsEvents } from '../../../components/GoogleAnalytics/index';
import Modal from '../../../components/UI/Modal/Modal';
import { DataAutomation } from '../CommonComponent/DataAutomationDetails/index';
import { getCrawlerStatus, initiateLegalCrawler, legalSectionTemplateRequest, initiateMasterDataSync, resyncItrAnalysis } from '../CommonComponent/action'
import { Preloading } from '../../../components/UI/Preloader/action';
import fileSaver from 'file-saver';

class CasesComponent extends Component {
  constructor(props) {
    super(props);
    this.formOneElement = React.createRef();
    this.downloadPendingCasesDataExcel = this.downloadPendingCasesDataExcel.bind(this);
    this.state = {
      activeTab: constant.PENDING,
      pendingCases: [],
      completedCases: [],
      withdrawnCases: [],
      onHoldCases: [],
      loading: true,
      isOpen: false,
      selectedSearchType: constant.SEARCH_PARAMETERS[0],
      popoverOpen: false,
      toDate: null,
      fromDate: null,
      selectedCorporate: [],
      searchText: '',
      searchCorporate: [],
      pageDescription: {},
      appliedFilters: [],
      clearAllButton: null,
      updateFlag: false,
      showModal: false,
      body: null,
      dataAutomationData: {},
      selectedRowData: {},
      requestBody: [],
      crawlerStatusFlag: false,
      productType: undefined,
      caseType: undefined,
      pendingCasesTableView:'',
      selectedProducts: [],
      availableProducts: [],
      productsLoading: false,
      productsError: ''
    };
    this.refreshInterval = null
  }

  toggle = (tab) => {
    this.props.preloading(true)
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      }, () => {
        if (this.state.activeTab === constant.PENDING) {
          this.onPendingFetchPage(this.state.activeTab, 0, constant.DEFAULT_PAGE_SIZE, { id: "dueDate", desc: true });
        } else if (this.state.activeTab === constant.COMPLETED) {
          this.onCompletedFetchPage(this.state.activeTab, 0, constant.DEFAULT_PAGE_SIZE, { id: "dueDate", desc: true });
        } else if (this.state.activeTab === constant.ONHOLD) {
          this.onOnHoldFetchPage(this.state.activeTab, 0, constant.DEFAULT_PAGE_SIZE, { id: 'dueDate', desc: true });
        } else if (this.state.activeTab === constant.WITHDRAWN) {
          this.onWithdrawnFetchPage(this.state.activeTab, 0, constant.DEFAULT_PAGE_SIZE, { id: 'dueDate', desc: true });
        }
      });
    } else {
      this.props.preloading(false)
    }
  }
  componentDidUpdate(prevProps) {
    // Case list fetching was successful
    if (this.props.location.search !== prevProps.location.search) {
      this.setState(() => {
        const urlFilters = getUrlFilter(this.props.location.search)
        let date = {
          toDate: urlFilters.toDate,
          fromDate: urlFilters.fromDate
        }
        this.caseListFilterCallBack(urlFilters.productType, urlFilters.caseType, urlFilters.selectedCorporates, date, urlFilters.selectedProducts || [], false, true);
      });
    }

    // If download pending cases excel was successful
    if (this.props.downloadPendingCasesValues !== prevProps.downloadPendingCasesValues) {
      var blob = new Blob([this.props.downloadPendingCasesValues.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' });
      fileSaver.saveAs(blob, 'Pending_Cases.xlsx');
      this.props.preloading(false);
      // goolgeAnalyticsEvents('Pending case', 'Download Pending Case Excel File', 'Download', '');
    }
    if (this.props.downloadPendingCasesFailure !== prevProps.downloadPendingCasesFailure) {
      this.props.preloading(false);
    }

    if (this.props.legalCrawler !== prevProps.legalCrawler) {
      if (this.props.legalCrawler.status === "SUCCESS") {
        toast.success(
          <div>
            <i className="fa fa-exclamation-triangle"></i>&nbsp;Crawler Initiated
            Successfully
          </div>,
        );
      } else {
        toast.error(
          <div>
            <i className="fa fa-exclamation-triangle"></i>&nbsp;{this.props.legalCrawler.data.data.message}
          </div>
        );
      }
      this.fetchCrawlerStatus();
    }

    if (this.props.itrResyncAt && this.props.itrResyncAt !== prevProps.itrResyncAt) {
      this.props.preloading(false);
      if (this.props.itrResyncStatus === "SUCCESS") {
        toast.success(
          <div>
            <i className="fa fa-check-circle"></i>&nbsp;{this.props.itrResyncMessage}
          </div>
        );
      } else if (this.props.itrResyncStatus === "FAILURE") {
        toast.error(
          <div>
            <i className="fa fa-exclamation-triangle"></i>&nbsp;{this.props.itrResyncMessage}
          </div>
        );
      }
    }

    if (this.props.automationInitiatedFailure !== prevProps.automationInitiatedFailure) {
      toast.error(
        <div>
          <i className="fa fa-exclamation-triangle"></i>&nbsp;{this.props.automationInitiatedFailure.data.message}
        </div>
      );
    }
    if (this.props.automationInitiatedSuccess !== prevProps.automationInitiatedSuccess) {
      toast.success(
        <div>
          <i className="fa fa-exclamation-triangle"></i>&nbsp;Crawler Initiated Successfully
        </div>
      );
      this.setState({
        dataAutomationData: {}
      })
    }
    if (this.props.corporateNameListFailure !== prevProps.corporateNameListFailure) {
      toast.error(
        <div>
          <i className="fa fa-exclamation-triangle"></i>&nbsp;{this.props.corporateNameListFailure.data.message}
        </div>
      );
    }
    if (this.props.cases !== prevProps.cases) {
      this.props.preloading(false)
      if (this.state.activeTab === constant.PENDING) {
        let tempCaseData = updateCaseDataWithCrawlerFlag(this.props.cases.data)
        let tableView = <TableView
                            tasks={tempCaseData}
                            loading={this.state.loading}
                            status={constant.PENDING}
                            getCrawlerStatus={this.fetchCrawlerStatus}
                            onFetchPage={this.onPendingFetchPage}
                            crawlersInitiateCallback={this.handleCrawlerInitiate} />
        this.setState({
          loading: false,
          pendingCases: tempCaseData,
          pendingCasesTableView: tableView,
          completedCases: [],
          withdrawnCases: [],
          onHoldCases: [],
        })
        this.fetchCrawlerStatus();
      } else if (this.state.activeTab === constant.COMPLETED) {
        this.setState({
          completedCases: this.props.cases.data,
          pendingCases: [],
          withdrawnCases: [],
          onHoldCases: [],
          loading: false
        })
      } else if (this.state.activeTab === constant.WITHDRAWN) {
        this.setState({
          withdrawnCases: this.props.cases.data,
          pendingCases: [],
          completedCases: [],
          onHoldCases: [],
          loading: false
        })
      } else if (this.state.activeTab === constant.ONHOLD) {
        this.setState({
          onHoldCases: this.props.cases.data,
          withdrawnCases: [],
          pendingCases: [],
          completedCases: [],
          loading: false
        })
      }
    }
    // Case list fetching was failure
    else if (this.props.casesErr !== prevProps.casesErr) {
      this.setState({
        loading: false
      });
    }
    if (this.props.crawlerStatusSuccess !== prevProps.crawlerStatusSuccess) {
      if (this.state.activeTab === constant.PENDING) {
        let tempCaseData = updateCrawlerStatusinCaseData(this.props.cases.data, this.props.crawlerStatusSuccess)
        this.setState({
          pendingCases: tempCaseData,
          pendingCasesTableView:(<TableView
            tasks={tempCaseData}
            loading={this.state.loading}
            status={constant.PENDING}
            getCrawlerStatus={this.fetchCrawlerStatus}
            onFetchPage={this.onPendingFetchPage}
            crawlersInitiateCallback={this.handleCrawlerInitiate} />),
          completedCases: [],
          withdrawnCases: [],
          onHoldCases: [],
          loading: false
        })
      }

    }

    if (this.props.availableProducts !== prevProps.availableProducts) {
      this.setState({
        availableProducts: this.props.availableProducts || [],
        productsLoading: this.props.productsLoading || false
      });
    }

    if (this.props.productsError !== prevProps.productsError) {
      this.setState({
        productsError: this.props.productsError
      });
    }
  }
  componentDidMount() {
    const { userDetails, getCorporateName, history, location, viewAll, activeTab } = this.props;

    if (userDetails.scopes === 'ROLE_RUBIXANALYST') {
        setPageView('/Analyst/Caselist', document.location.href);
    } else {
        setPageView('/Admin/Caselist', document.location.href);
    }

    getCorporateName();
    history.push(location);

    const urlFilters = getUrlFilter(location.search);
    if (urlFilters) {
        const date = {
            toDate: urlFilters.toDate,
            fromDate: urlFilters.fromDate
        };

        this.setState({
            pageDescription: {
                status: constant.PENDING,
                pageNo: 0,
                pageSize: 10,
                sorted: {
                    desc: true,
                    id: "dueDate"
                }
            }
        }, () => {
            this.caseListFilterCallBack(
                urlFilters.productType,
                urlFilters.caseType,
                urlFilters.selectedCorporates,
                date,
                 this.state.selectedProducts,
                false,
                false
            );
        });
    }

    viewAll(activeTab);
    this.onPendingFetchPage(constant.PENDING, 0, constant.DEFAULT_PAGE_SIZE, { id: "dueDate", desc: true });
}
  componentWillUnmount = () => {
    clearTimeout(this.refreshInterval);
    this.refreshInterval = 0
  };

  fetchCrawlerStatus = () => {
    let counterpartyIdList = getCounterpartyIdWithCorporateIdList(this.props.cases.data);
    if (counterpartyIdList && counterpartyIdList.length > 0) {
      this.props.getCrawlerStatus(counterpartyIdList);
    }
  }
 
  onPendingFetchPage = (status, pageNo, pageSize, sorted) => {
    this.setState({
      loading: true,
      pageDescription: {
        status: status,
        pageNo: pageNo,
        pageSize: pageSize,
        sorted: sorted
      }
    });
    const tempPageDescription = getPageDescriptionBody({ status, pageNo, pageSize, sorted });
    const date = {
      toDate: this.state.toDate,
      fromDate: this.state.fromDate
    }
    const tempRequestBody = setRequestBody(this.state.productType, this.state.caseType, this.state.searchCorporate, date, this.state.searchText, this.state.selectedProducts)
    this.props.viewPage(tempPageDescription, tempRequestBody);
  }

  onCompletedFetchPage = (status, pageNo, pageSize, sorted) => {
    this.setState({
      loading: true,
      pageDescription: {
        status: status,
        pageNo: pageNo,
        pageSize: pageSize,
        sorted: sorted
      }
    });
    const tempPageDescription = getPageDescriptionBody({ status, pageNo, pageSize, sorted });
    const date = {
      toDate: this.state.toDate,
      fromDate: this.state.fromDate
    }
    const tempRequestBody = setRequestBody(this.state.productType, this.state.caseType, this.state.searchCorporate, date, this.state.searchText, this.state.selectedProducts)
    this.props.viewPage(tempPageDescription, tempRequestBody);
  }

  onOnHoldFetchPage = (status, pageNo, pageSize, sorted) => {
    this.setState({
      loading: true,
      pageDescription: {
        status: status,
        pageNo: pageNo,
        pageSize: pageSize,
        sorted: sorted
      }
    });
    const tempPageDescription = getPageDescriptionBody({ status, pageNo, pageSize, sorted });
    const date = {
      toDate: this.state.toDate,
      fromDate: this.state.fromDate
    }
    const tempRequestBody = setRequestBody(this.state.productType, this.state.caseType, this.state.searchCorporate, date, this.state.searchText, this.state.selectedProducts)
    this.props.viewPage(tempPageDescription, tempRequestBody);
  }

  onWithdrawnFetchPage = (status, pageNo, pageSize, sorted) => {
    this.setState({
      loading: true,
      pageDescription: {
        status: status,
        pageNo: pageNo,
        pageSize: pageSize,
        sorted: sorted
      }
    });
    const tempPageDescription = getPageDescriptionBody({ status, pageNo, pageSize, sorted });
    const date = {
      toDate: this.state.toDate,
      fromDate: this.state.fromDate
    }
    const tempRequestBody = setRequestBody(this.state.productType, this.state.caseType, this.state.searchCorporate, date, this.state.searchText, this.state.selectedProducts)
    this.props.viewPage(tempPageDescription, tempRequestBody)
  }
  caseListFilterCallBack = (productType, caseType, data, date, selectedProducts, popoverFlag, filterResetFlag) => {
    const tempAppliedFilters = setAppliedFilters(productType, caseType, data, date, selectedProducts);
    this.setState({
      toDate: date.toDate,
      fromDate: date.fromDate,
      productType: productType,
      caseType: caseType,
      searchCorporate: data,
      selectedProducts: selectedProducts,
      updateFlag: true,
      loading: true,
      appliedFilters: tempAppliedFilters,
      clearAllButton: (tempAppliedFilters.length > 0) ? <Button className="filter-item filter-item-btn-clear" color="link" size="xs" onClick={this.handleClearAll}>Clear All</Button> : null,
    });

    const tempPageDescription = getPageDescriptionBody(this.state.pageDescription);
    const requestBody = setRequestBody(productType, caseType, data, date, this.state.searchText, selectedProducts);
    this.props.viewPage(tempPageDescription, requestBody);

    if (popoverFlag && !filterResetFlag) {
      const url = createFilterUrl(productType, caseType, date, data, selectedProducts);
      this.props.history.push(`?${url}`);
      this.popovertoggle();
    } else if (popoverFlag && filterResetFlag) {
      this.props.history.push(`?${""}`);
    }
  }
  handleRemoveFilter = (removeFilter) => {
    let clearButton, toDate = this.state.toDate, fromDate = this.state.fromDate, removeEntityFilterList = [...this.state.searchCorporate], selectedProducts = [...this.state.selectedProducts];
    const removeFilterList = deleteAppliedFilters(removeFilter, this.state.appliedFilters);
    if (removeFilterList.length > 0) {
      clearButton = <Button className="filter-item filter-item-btn-clear" color="link" size="xs" onClick={this.handleClearAll}>Clear All</Button>
    } else {
      clearButton = null
    }
    if (removeFilter.value === constant.DATE_TEXT) {
      fromDate = null
      toDate = null
    } else if (removeFilter.type === 'product') {
      selectedProducts = selectedProducts.filter(product => product.value !== removeFilter.value);
    } else {
      removeEntityFilterList = deleteEntityFilter(this.state.searchCorporate, removeFilter);
      toDate = this.state.toDate
      fromDate = this.state.fromDate
    }
    this.setState({
      appliedFilters: removeFilterList,
      clearAllButton: clearButton,
      searchCorporate: removeEntityFilterList,
      selectedProducts: selectedProducts,
      fromDate: fromDate,
      toDate: toDate,
      loading: true
    });
    const tempPageDescription = getPageDescriptionBody(this.state.pageDescription);

    const date = {
      toDate: toDate,
      fromDate: fromDate,
    }
    if (removeFilter.value === 'productType') {
      this.state.productType = undefined;
    }
    if (removeFilter.value === 'caseType') {
      this.state.caseType = undefined;
    }
    const tempRequestBody = setRequestBody(this.state.productType, this.state.caseType, removeEntityFilterList, date, this.state.searchText, selectedProducts)
    this.props.viewPage(tempPageDescription, tempRequestBody)

    const url = createFilterUrl(this.state.productType, this.state.caseType, date, removeEntityFilterList, selectedProducts);
    this.props.history.push(`?${url}`);

    this.formOneElement.current.handleRemoveFilter(removeFilter); // Removes item from popover filter
  }
  handleClearAll = () => {
    this.setState({
      productType: null,
      caseType: null,
      appliedFilters: [],
      toDate: null,
      fromDate: null,
      searchCorporate: [],
      selectedProducts: [],
      clearAllButton: null,
      loading: true
    }, () => {
      const tempPageDescription = getPageDescriptionBody(this.state.pageDescription);
      const date = {
        toDate: this.state.toDate,
        fromDate: this.state.fromDate
      }
      const tempRequestBody = setRequestBody(this.state.productType, this.state.caseType, this.state.searchCorporate, date, this.state.searchText, this.state.selectedProducts)
      this.props.viewPage(tempPageDescription, tempRequestBody)
      this.props.history.push(`?${""}`);
    })
    this.formOneElement.current.handleResetDateFilter() // Reset popover filter
  }
  handleToggle = () => {
    this.setState((prevState) => ({
      isOpen: !prevState.isOpen
    }))
  }
  popovertoggle = () => {
    this.setState((prevState) => ({
      popoverOpen: !prevState.popoverOpen
    }));
    this.formOneElement.current.handleFilterOnPageRefreshOrBackButton(getUrlFilter(this.props.location.search));
  }
  dropdownCallback = (data) => {
    this.setState({
      selectedSearchType: data
    })
  }
  handleSearchChange = (event) => {
    if (event.key === constant.ENTER) {
      event.preventDefault()
      this.props.preloading(true)
      const value = event.target.value; 
      const tempPageDescription = getPageDescriptionBody(this.state.pageDescription);
      const date = {
        toDate: this.state.toDate,
        fromDate: this.state.fromDate
      }
      
    this.setState({ searchText: value }, () => {
          const requestBody = setRequestBody(
            this.state.productType,
            this.state.caseType,
            this.state.searchCorporate,
            date,
            value,
            this.state.selectedProducts
          );
          this.props.viewPage(tempPageDescription, requestBody);
        });
    }
  }
  toggleModal = () => {
    this.setState(prevState => ({
      showModal: !prevState.showModal
    }))
  }

  closeModal = () => {
    this.setState({
      dataAutomationData: {}
    }, () => {
      this.toggleModal()
    })
  }
  handleCrawlerInitiate = (selectedRowData, flag) => {
    this.setState({ caseData: { ...selectedRowData, 'LEGAL_name': selectedRowData.counterpartyName } }, () => {
      let selectedCounterpartyStatus = getStatusData(this.props.crawlerStatusSuccess, selectedRowData);
      this.setState({
        selectedRowData: selectedRowData,
        selectedCounterpartyStatus: selectedCounterpartyStatus
      }, () => {
        if (flag) {
          this.toggleModal();
        }
      })
    })
  }
  handleLegalData = (e) => {
    if (e.target.checked) {
    } else {
    }
    let tempAutomationData = {
      ...this.state.caseData,
      'LEGAL': true,
      [e.target.name]: e.target.value
    };
    this.setState({
      caseData: tempAutomationData,
    });
  }

  handleRatingsData = (e) => {
    let tempAutomationData = {
      ...this.state.caseData,
      [e.target.name]: e.target.value
    };

    this.setState({
      caseData: tempAutomationData
    })
  }

  handleBseNseData = (e) => {
    let tempAutomationData = {
      ...this.state.caseData,
      [e.target.name]: e.target.value
    };
    this.setState({
      caseData: tempAutomationData
    })
  }

  handleLeiData = (e) => {
    let tempAutomationData = {
      ...this.state.caseData,
      [e.target.name]: e.target.value
    };

    this.setState({
      caseData: tempAutomationData
    })
  }

  handleCheckboxchange = (event) => {
    let tempData = event.target.name
    let dataAutomation = Object.assign({}, this.state.dataAutomationData);
    dataAutomation = {
      ...dataAutomation,
      [tempData]: event.target.checked
    }
    this.setState({
      dataAutomationData: dataAutomation,
      selectedRowData: { ...this.state.selectedRowData, ...dataAutomation }
    }, () => {

      this.handleCrawlerInitiate(this.state.selectedRowData, false)
    })
  }
  handleDataAutomationRequiredData = (event) => {
    // Check if there is any data in the text
    if (event.target.value) {
      let tempAutomationData = {};

      // Cleaning up the input ids:- 
      // 1. Trimming from start and end - replace(/^\s+|\s+$/g,"")
      // 2. Splitting and trimming spaces from each element - split(/\s*,\s*/)
      // 3. Removing the blank elements - filter(function () { return true })
      let tempCrawlerInput = event.target.value.replace(/^\s+|\s+$/g,"").split(/\s*,\s*/).filter(function (el) { return el != null && el != undefined && el != "" });

      if (event.target.name === "GST") {
        tempAutomationData = {
          ...this.state.selectedRowData,
          gstNo: tempCrawlerInput
        }
      }  else if (event.target.name === "NEWS") {
        tempAutomationData = {
          ...this.state.selectedRowData,
          counterpartyName: tempCrawlerInput
        }
      }
      else {
        tempAutomationData = {
          ...this.state.selectedRowData,
          [event.target.name]: tempCrawlerInput
        }
      }

      this.setState({
        selectedRowData: tempAutomationData
      })
    }
  }

  handleRunAutomation = () => {
    console.log("Running automation with data:", this.state.selectedRowData);
    let validateAutomationDataFlagMessage = validateAutomationData(this.state.dataAutomationData, this.state.selectedRowData, this.state.caseData);
    if (validateAutomationDataFlagMessage.length < 1) {
      let tempRequestBody = setRequestBodyDataAutomation(this.state.dataAutomationData, this.state.selectedRowData, this.state.caseData);
      let legalRequestBody = {
        corporateId: this.state.caseData.corporateId,
        counterpartyId: this.state.caseData.counterpartyId,
        caseId: this.state.caseData.caseId,
        crawlerName: 'LEGAL',
        counterpartyName: this.state.caseData.LEGAL_name, /* address: this.state.caseData.LEGAL_address, */ type: "Entity",
        state: this.state.caseData.state
      }
      if ("API" == this.state.selectedRowData.requestType) {
        legalRequestBody = { ...legalRequestBody, requestType: "API" };
      }
      if (this.state.dataAutomationData.LEGAL) {
        this.props.initiateLegalCrawler(legalRequestBody);
      }
      if (this.state.dataAutomationData.GST || this.state.dataAutomationData.PAN || this.state.dataAutomationData.MCA || this.state.dataAutomationData.DIN || this.state.EPF || this.state.dataAutomationData.RATINGS || this.state.dataAutomationData.STOCK_EXCHANGE || this.state.dataAutomationData.GST_ANALYSIS) {
        this.props.dataAtuomationInitiate(tempRequestBody);
      }
      this.toggleModal()
    } else {
      toast.error(
        <div>
          <i className="fa fa-exclamation-triangle"></i>&nbsp;{validateAutomationDataFlagMessage}
        </div>
      );
    }
  }

  downloadPendingCasesDataExcel = () => {
    this.props.preloading(true);
    const fromToDate = { toDate: this.state.toDate, fromDate: this.state.fromDate };
    this.props.downloadPendingCases(setRequestBody(this.state.productType, this.state.caseType, this.state.searchCorporate, fromToDate, this.state.searchText, this.state.selectedProducts));
  }

  handleItrResync = () => {
    const row = this.state.selectedRowData || {};
    const corporateId = row.corporateId || (this.state.caseData && this.state.caseData.corporateId);
    if (!row.counterpartyId || !corporateId) {
      toast.error(
        <div>
          <i className="fa fa-exclamation-triangle"></i>&nbsp;Counterparty details are missing for ITR resync
        </div>
      );
      return;
    }
    this.props.preloading(true);
    this.toggleModal();
    this.props.resyncItrAnalysis({
      counterpartyId: row.counterpartyId,
      corporateId
    });
  }

  render() {

    return (
      <Col>
        <Card>
          <CardBody>
            <Row className="search-case">
              <Col sm='12'>
                <Form className="form-search">
                  <FormGroup className="mb-0 input-search">
                    <i className="icon-search position-absolute"></i>
                    <Input className="bg-light" type="search" name="search" id="search" onKeyPress={this.handleSearchChange} placeholder="Search NAME,GST,PAN,CIN & MISORDER ID" autoComplete="off" />
                  </FormGroup>
                </Form>
              </Col>

              <Col sm='2'>
                <div className="filter-wrapper ml-auto">
                  <div>
                    <Button id="Popover1" className={this.state.popoverOpen ? 'btn-filter btn-icon filter-popover-open' : 'btn-filter btn-icon'} outline size="sm" color="primary" onClick={this.popovertoggle}>
                      <i className="icon-filter"></i>
                    </Button>
                    {/*<Button color="primary" outline size="sm" className="ml-3 d-sm-none">Applied Filters</Button>*/}
                  </div>
                </div>
              </Col>
              <Col sm='6'>
                <Row lg='7'>
                  <Button size="lg" className="min-w-15 btn btn-primary btn-lg" color="primary" onClick={() => { this.downloadPendingCasesDataExcel() }}>Download Pending Cases</Button>
                </Row>
              </Col>

            </Row>
            <div className={this.state.popoverOpen ? "position-absolute filter-popover case-filter-popover d-block bg-light p-4" : "position-absolute filter-popover d-none p-3"}>
              <FilterFormTypeOne
                updateFlag={this.state.updateFlag}
                multiselectTitle='Corporate Name'
                correspondentList={this.props.corporateNameList}
                dateFilterType='Created On'
                hideFilterCallback={this.popovertoggle}
                filterCallback={this.caseListFilterCallBack}
                dateFilters={{ toDate: this.state.toDate, fromDate: this.state.fromDate }}
                selectedEntity={this.state.searchCorporate}
                productTypeFlag={true}
                caseTypeFlag={true}
                availableProducts={this.state.availableProducts}
                productsLoading={this.state.productsLoading}
                productsError={this.state.productsError}
                fetchProductsByCorporates={this.props.fetchProductsByCorporates}
                ref={this.formOneElement} />
            </div>
            <div className="row no-gutters mb-3 d-flex flex-column flex-sm-row">
              <Label className={this.state.appliedFilters.length > 0 ? "filter-title col-sm-3 pr-0" : 'hidden'}>Applied Filters :</Label>
              <div className="col-sm-21 pl-0 filter d-flex flex-wrap align-items-center">
                {this.state.appliedFilters.map(p => {
                  return (
                    <span key={p.value} className="filter-item d-flex align-items-center mr-2 mb-2">
                      {decodeURIComponent(p.label)} <i className="icon-close" onClick={() => this.handleRemoveFilter(p)}></i>
                    </span>
                  )
                })}
                {this.state.clearAllButton}
              </div>
            </div>
            <Nav tabs>
              <NavItem>
                <NavLink href="#"
                  className={classnames({ active: this.state.activeTab === constant.PENDING })}
                  onClick={() => { this.toggle(constant.PENDING); }}>
                  Pending Cases
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="#"
                  className={classnames({ active: this.state.activeTab === constant.COMPLETED })}
                  onClick={() => { this.toggle(constant.COMPLETED); }}>
                  Completed Cases
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="#"
                  className={classnames({ active: this.state.activeTab === constant.ONHOLD })}
                  onClick={() => { this.toggle(constant.ONHOLD); }}>
                  On Hold Cases
                </NavLink>
              </NavItem>
              <NavItem></NavItem>
              <NavItem>
                <NavLink href="#"
                  className={classnames({ active: this.state.activeTab === constant.WITHDRAWN })}
                  onClick={() => { this.toggle(constant.WITHDRAWN); }}>
                  Withdrawn Cases
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent activeTab={this.state.activeTab}>
              <TabPane tabId={constant.PENDING}>
                <Row>
                  <div className="col">
                    {this.state.activeTab === constant.PENDING && <TableView
                      tasks={this.state.pendingCases}
                      loading={this.state.loading}
                      status={constant.PENDING}
                      getCrawlerStatus={this.fetchCrawlerStatus}
                      onFetchPage={this.onPendingFetchPage}
                      crawlersInitiateCallback={this.handleCrawlerInitiate} />}
                  </div>
                </Row>
              </TabPane>
              <TabPane tabId={constant.COMPLETED}>
                <Row>
                  <div className="col">
                  {this.state.activeTab === constant.COMPLETED && <TableView tasks={this.state.completedCases}
                      loading={this.state.loading}
                      status={constant.COMPLETED}
                      getCrawlerStatus={{}}
                      onFetchPage={this.onCompletedFetchPage}
                      crawlersInitiateCallback={this.handleCrawlerInitiate} />}
                  </div>
                </Row>
              </TabPane>
              <TabPane tabId={constant.ONHOLD}>
                <Row>
                  <div className="col">
                    {this.state.activeTab === constant.ONHOLD &&<TableView tasks={this.state.onHoldCases}
                      loading={this.state.loading}
                      status={constant.ONHOLD}
                      getCrawlerStatus={{}}
                      onFetchPage={this.onOnHoldFetchPage}
                      crawlersInitiateCallback={this.handleCrawlerInitiate} />}
                  </div>
                </Row>
              </TabPane>
              <TabPane tabId={constant.WITHDRAWN}>
                <Row>
                  <div className="col">
                    {this.state.activeTab === constant.WITHDRAWN &&<TableView tasks={this.state.withdrawnCases}
                      loading={this.state.loading}
                      status={constant.WITHDRAWN}
                      getCrawlerStatus={{}}
                      onFetchPage={this.onWithdrawnFetchPage}
                      crawlersInitiateCallback={this.handleCrawlerInitiate} />}
                  </div>
                </Row>
              </TabPane>
            </TabContent>
          </CardBody>
        </Card>
        <Modal show={this.state.showModal} className="Large-Modal" modalClosed={this.handleModalToggle} >
          {this.state.showModal && <DataAutomation
            selectedCounterpartyStatus={this.state.selectedCounterpartyStatus}
            selectedRowData={this.state.selectedRowData}
            handleTextChange={this.handleDataAutomationRequiredData}
            handleRunCallback={this.handleRunAutomation}
            dataAutomationData={this.state.dataAutomationData}
            handleCheckboxchange={this.handleCheckboxchange}
            markCrawlerAsfailure={this.markCrawlerAsfail}
            close={this.closeModal}
            handleLegalData={this.handleLegalData}
            handleRatingsData={this.handleRatingsData}
            handleLeiData={this.handleLeiData}
            handleBseNseData={this.handleBseNseData}
            ratingsType={this.state.caseData.ratingsSearchType}
            stockType={this.state.caseData.stockType}
            isListPage={true}
            name={this.state.caseData.LEGAL_name}
            epfData={this.props.epfData}
            handleItrResync={this.handleItrResync}
            userDetails={this.props.userDetails} />}
            
        </Modal>
      </Col>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  //let id = ownProps.match.params.post_id;
  userDetails: state.loginDetails.userDetails,
  cases: state.cases.viewPaginatedListSuccess,
  casesErr: state.cases.viewPaginatedListFailure, //state.cases.viewAllListSuccess,
  downloadPendingCasesValues: state.cases.downloadPendingCases,
  downloadPendingCasesFailure: state.cases.downloadPendingCasesFailure,
  corporateNameList: state.cases.corporateNameList,
  corporateNameListFailure: state.cases.corporateNameListFailure,
  availableProducts: state.cases.availableProducts,
  productsLoading: state.cases.productsLoading,
  productsError: state.cases.productsError,
  automationInitiatedSuccess: state.commonCaseComponentReducer.automationInitiatedSuccess,
  automationInitiatedFailure: state.commonCaseComponentReducer.automationInitiatedFailure,
  crawlerStatusSuccess: state.commonCaseComponentReducer.crawlerStatusSuccess,
  crawlerStatusFailure: state.commonCaseComponentReducer.crawlerStatusFailure,
  CrawlerMarkasfailSuccess: state.commonCaseComponentReducer.CrawlerMarkasfailSuccess,
  CrawlerMarkasfailFailure: state.commonCaseComponentReducer.CrawlerMarkasfailFailure,
  legalCrawler: state.commonCaseComponentReducer.legalCrawler,
  epfData: state.cases.epfData,
  itrResyncStatus: state.commonCaseComponentReducer.itrResyncStatus,
  itrResyncMessage: state.commonCaseComponentReducer.itrResyncMessage,
  itrResyncAt: state.commonCaseComponentReducer.itrResyncAt,
})

const mapDispatchToProps = (dispatch) => ({
  viewAll: (status) => { dispatch(viewAllCases(status)); },
  viewPage: (pageDescription, requestBody) => { dispatch(viewPaginatedCases({ pageDescription, requestBody })); },
  dataAtuomationInitiate: (data) => { dispatch(dataAtuomationInitiate(data)) },
  getCorporateName: () => { dispatch(getCorporateName()) },
  fetchProductsByCorporates: (corporateIds) => { dispatch(fetchProductsByCorporates(corporateIds)) },
  getCrawlerStatus: (data) => { dispatch(getCrawlerStatus(data)) },
  initiateLegalCrawler: (data) => { dispatch(initiateLegalCrawler(data)) },
  legalSectionTemplateRequest: (data) => { dispatch(legalSectionTemplateRequest(data)) },
  preloading: (isPreloading) => { dispatch(Preloading(isPreloading)); },
  //getCaseEPFDetails: id => { dispatch(getCaseEPFDetails(id)); },
  downloadPendingCases: (data) => { dispatch(downloadPendingCases(data)); },
  downloadPendingCasesSuccess: (data) => { dispatch(downloadPendingCasesSuccess(data)) },
  initiateMasterDataSync: (counterpartyId) => 
            dispatch(initiateMasterDataSync(counterpartyId)),
  resyncItrAnalysis: (data) => { dispatch(resyncItrAnalysis(data)); },

});
export default withAuth(connect(mapStateToProps, mapDispatchToProps)(CasesComponent))